import axios from 'axios';
import { FETCH_USER, HYDRATE_AUTH, SET_LOADING, CLEAR_AUTH } from './types';

export const hydrateAuth = (authData) => dispatch => {
    dispatch({
        type: HYDRATE_AUTH,
        payload: authData
    });
};

export const setLoading = (loading) => {
    return {
        type: SET_LOADING,
        payload: loading
    };
};

export const clearAuth = () => {
    return {
        type: CLEAR_AUTH
    };
};

export const fetchUser = () => async dispatch => {
    // Set loading state
    dispatch(setLoading(true));

    try {
        const res = await axios.get('/api/current_user');
        
        // Set localStorage based on authentication result
        if (res.data && res.data.id) {
            localStorage.setItem('isAuthenticated', 'true');
            localStorage.setItem('authData', JSON.stringify(res.data));
            
            // Only clear onboarding data if user has completed onboarding
            if (res.data.permission && res.data.permission.show_onboarding === false) {
                localStorage.removeItem('onboardingData');
            }
        } else {
            localStorage.setItem('isAuthenticated', 'false');
            localStorage.removeItem('authData');
        }
        
        dispatch({ type: FETCH_USER, payload: res.data });
    } catch (error) {
        console.error('Error fetching user:', error);
        dispatch({ type: FETCH_USER, payload: null });
    }
};